import {testIdProps} from '@github-ui/test-id-props'
import {FoldDownIcon, FoldUpIcon, KebabHorizontalIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, IconButton} from '@primer/react'

interface IterationActionsMenuProps {
  /** Callback to insert a break above this iteration */
  onInsertBreakAbove?: () => void
  /** Callback to insert a break below this iteration */
  onInsertBreakBelow?: () => void
}

export function IterationActionsMenu({onInsertBreakAbove, onInsertBreakBelow}: IterationActionsMenuProps) {
  if (!onInsertBreakAbove && !onInsertBreakBelow) {
    return null
  }

  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <IconButton
          icon={KebabHorizontalIcon}
          variant="invisible"
          aria-label="Insert break"
          size="small"
          {...testIdProps('iteration-actions-menu')}
        />
      </ActionMenu.Anchor>
      <ActionMenu.Overlay>
        <ActionList>
          {onInsertBreakAbove && (
            <ActionList.Item onSelect={onInsertBreakAbove} {...testIdProps('insert-break-above-action')}>
              <ActionList.LeadingVisual>
                <FoldUpIcon />
              </ActionList.LeadingVisual>
              Insert break above
            </ActionList.Item>
          )}
          {onInsertBreakBelow && (
            <ActionList.Item onSelect={onInsertBreakBelow} {...testIdProps('insert-break-below-action')}>
              <ActionList.LeadingVisual>
                <FoldDownIcon />
              </ActionList.LeadingVisual>
              Insert break below
            </ActionList.Item>
          )}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}

try{ IterationActionsMenu.displayName ||= 'IterationActionsMenu' } catch {}